import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	min-height: 56px;
	display: flex;
	align-items: center;
	padding-right: 16px;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
`;

export const InfoWrapper = styled.div`
	font-size: 13px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};
	margin-left: auto;
	display: flex;
	align-items: center;

	span {
		padding-right: 8px;
	}
`;

export const ButtonsWrapper = styled.div`
	display: flex;

	button {
		margin-left: 8px;
	}
`;
